// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rEgc","colMin":"styles_colMin__1KMpw"};